import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { EppPortlet, PortletRepo, registerInnerWidget } from '@gspwidget/util';
import { DataJumpConfig, dataJumpOption, JumpTypes, Property, PropertyTypes, Widget, WidgetBase, WidgetDevkitService } from '@gspwidget/widget-devkit';
import { forkJoin } from 'rxjs';

export interface Tab {
  /** ä»ä½èéç½®é¡¹å¼å®¹ */
  portletId: string
  portletIds: string[]
  rightJump: DataJumpConfig
  title?: string
  feOnly?: {
    portlets?: EppPortlet[]
  }
}

@Widget({ name: 'shell-tab', enableCommonTitleBar: true, })
@Component({
  selector: 'lib-shell-tab',
  templateUrl: './shell-tab.component.html',
  styleUrls: ['./shell-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShellTabComponent extends WidgetBase {

  @Property({
    isArray: true,
    type: PropertyTypes.Object,
    objectOption: {
      objPropertyOptions: [{
        displayName: 'portlet',
        name: 'portletIds',
        type: PropertyTypes.Help2,
        isArray: true,
        help2Option: {
          preset: 'eppPortlet',
          valueField: 'id',
          labelField: 'name',
        }
      }, {
        name: 'title',
        displayName: 'æ ç­¾å',
      }, {
        name: 'rightJump',
        ...dataJumpOption,
      }]
    }
  }) tabConfigs: Tab[]

  activeTab: Tab
  readonly JumpTypes = JumpTypes

  constructor (
    public portletRepo: PortletRepo,
    public cd: ChangeDetectorRef,
    public widgetDevkitService: WidgetDevkitService,
  ) {
    super()
  }

  ngOnInit () {
    console.log(this.tabConfigs)
    this.refreshPortletsByIds()
  }
  onPropChange() {
    this.refreshPortletsByIds()
  }

  refreshPortletsByIds () {
    if (!this.tabConfigs) return
    this.tabConfigs.forEach(c => {
      if (!c.feOnly) c.feOnly = {}
      // å¼å®¹èç portletId
      if (c.portletId && (!c.portletIds || !c.portletIds[0])) c.portletIds = [c.portletId]
      const getPortlets$ = c.portletIds
        .filter(id => id)
        .map(id => this.portletRepo.getPortletById(id))
      forkJoin(getPortlets$).subscribe(ps => {
        c.feOnly.portlets = ps
        this.cd.markForCheck()
      })
    })
    this.activeTab = this.tabConfigs[0]
  }

  handleClickRightTopJump () {
    this.widgetDevkitService.jumpWithoutData(this.activeTab.rightJump)
  }

  /** ä¸å®¹ææ¥éçè·åç¬¬ä¸ä¸ª portlet */
  getFirstPortletOfTab (tab: Tab) {
    return tab
      && tab.feOnly
      && tab.feOnly.portlets
      && tab.feOnly.portlets[0]
      && tab.feOnly.portlets[0].name
  }

}

registerInnerWidget({
  widgetComponent: ShellTabComponent,
  baseUrl: '',
  id: 'shell-tab',
  name: 'shell-tab',
  displayName: 'å®¹å¨-æ ç­¾',
  version: '6',
  isDevMode: true,
})
